const names = (
  "select hand image rectangle ellipse triangle line arrow pen bezier marquee lasso crop title text-field button input choice drop-zone drag " +
  "fill color stroke-width radius opacity blend blur shadow solid dashed dotted font font-size line-spacing letter-spacing bold italic underline sides depth cut copy delete merge object-align-left object-align-center-x object-align-right distribute-x object-align-top object-align-center-y object-align-bottom distribute-y"
).split(" ");
const atlas =
  "/templates/boxed/controllers/creatorenginepro/assets/color-icons-v1/atlas.png";
const mapped: Record<string, string> = {
  polygon: "triangle",
  star: "depth",
  "stroke-color": "color",
  "line-style": "dashed",
};
/** Reuse the original atlas without changing buttons, handlers, swatches or scene data. */
export class NativeIconTheme {
  private originals = new WeakMap<Element, string>();
  private applied = new WeakMap<Element, string>();
  private ready = false;
  private selected: "classic" | "color" = "classic";
  constructor(private root: HTMLElement) {
    const image = new Image();
    image.onload = () => {
      this.ready = true;
      this.sync();
    };
    image.src = atlas;
  }
  set(value: "classic" | "color") {
    this.selected = value;
    this.sync();
  }
  private icon(target: Element, name: string) {
    name = mapped[name] ?? name;
    const index = names.indexOf(name);
    if (index < 0) return;
    const key = this.ready && this.selected === "color" ? name : "classic";
    if (this.applied.get(target) === key) return;
    if (!this.originals.has(target))
      this.originals.set(target, target.innerHTML);
    target.innerHTML =
      key === "classic"
        ? this.originals.get(target)!
        : `<svg width="24" height="24" viewBox="${(index % 8) * 96} ${Math.floor(index / 8) * 96} 96 96" overflow="hidden"><image href="${atlas}" width="768" height="672"/></svg>`;
    target.classList.toggle("creator-color-icon", key !== "classic");
    this.applied.set(target, key);
  }
  sync() {
    this.root.dataset.editorIconSet = this.ready ? this.selected : "classic";
    this.root
      .querySelectorAll('symbol[id^="tool-icon-"]')
      .forEach((s) => this.icon(s, s.id.slice(10)));
    this.root
      .querySelectorAll<SVGElement>("svg[data-original-icon]")
      .forEach((s) => this.icon(s, s.dataset.originalIcon!));
    this.root
      .querySelectorAll<HTMLElement>("[data-native-icon]")
      .forEach((b) => {
        const svg = b.querySelector("svg");
        if (svg) this.icon(svg, b.dataset.nativeIcon!);
      });
    this.root
      .querySelectorAll<HTMLElement>("[data-native-align]")
      .forEach((b) => {
        const svg = b.querySelector("svg"),
          value = b.dataset.nativeAlign!;
        if (svg)
          this.icon(
            svg,
            value.startsWith("distribute") ? value : "object-align-" + value,
          );
      });
  }
}
